"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCommonSubscriptionWidgets = void 0;
var CancelSubscriptionPageIntroWidget_1 = require("./CancelSubscriptionPageIntroWidget");
var CustomerCancelSubscriptionProductWidget_1 = require("./CustomerCancelSubscriptionProductWidget");
var mtaPriceOutputWidget_1 = require("./mtaPriceOutputWidget");
var mtaSummaryPriceOutputWidget_1 = require("./mtaSummaryPriceOutputWidget");
var PremiumOutputWidget_1 = require("./PremiumOutputWidget");
var SubscriptionRecalculationBannerWidget_1 = require("./SubscriptionRecalculationBannerWidget");
var addCommonSubscriptionWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "cancelSubscriptionPageIntro",
        component: CancelSubscriptionPageIntroWidget_1.CancelSubscriptionPageIntroWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "cancellationProductSelector",
        component: CustomerCancelSubscriptionProductWidget_1.CustomerCancelSubscriptionProductWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "mtaPriceOutput",
        component: mtaPriceOutputWidget_1.MtaPriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "mtaSummaryPriceOutput",
        component: mtaSummaryPriceOutputWidget_1.MtaSummaryPriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "premiumOutput",
        component: PremiumOutputWidget_1.PremiumOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "subscriptionRecalculationBanner",
        component: SubscriptionRecalculationBannerWidget_1.SubscriptionRecalculationBannerWidget
    });
};
exports.addCommonSubscriptionWidgets = addCommonSubscriptionWidgets;
//# sourceMappingURL=index.js.map